import { all } from "redux-saga/effects";
import appSaga from "./app_saga";
import authSaga from "./auth_saga";
import bankMerchantSaga from "./bank_merchant_saga";
import businessCategorySaga from "./business_category_saga";
import consumerSaga from "./consumer_saga";
import emailSaga from "./email_saga";
import googleMapSaga from "./google_map_saga";
import locationSaga from "./location_saga";
import menuSaga from "./menu_saga";
import notificationSaga from "./notification_saga";
import orderSaga from "./order_saga";
import preferenceSaga from "./preference_saga";
import restaurantSaga from "./restaurant_saga";
import reviewSaga from "./review_saga";
import tableSaga from "./table_saga";
import voucherSaga from "./voucher_saga";
import walletSaga from "./wallet_saga";

// LOLOL Mall
import mallCancellationSaga from "./mall_cancellation_saga";
import mallCartSaga from "./mall_cart_saga";
import mallCategorySaga from "./mall_category_saga";
import mallOrderSaga from "./mall_order_saga";
import mallProductSaga from "./mall_product_saga";
import mallRefundSaga from "./mall_refund_saga";
import mallReviewSaga from "./mall_review_saga";
import mallShopSaga from "./mall_shop_saga";
import mallVoucherSaga from "./mall_voucher_saga";

export default function* rootSaga() {
  yield all([
    appSaga(),
    authSaga(),
    bankMerchantSaga(),
    businessCategorySaga(),
    consumerSaga(),
    emailSaga(),
    googleMapSaga(),
    locationSaga(),
    menuSaga(),
    notificationSaga(),
    orderSaga(),
    preferenceSaga(),
    restaurantSaga(),
    reviewSaga(),
    tableSaga(),
    voucherSaga(),
    walletSaga(),
    // LOLOL Mall
    mallCancellationSaga(),
    mallCartSaga(),
    mallCategorySaga(),
    mallOrderSaga(),
    mallProductSaga(),
    mallRefundSaga(),
    mallReviewSaga(),
    mallShopSaga(),
    mallVoucherSaga(),
  ]);
}
